import * as React from "react";

function SvgTrash(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 18 24"
      focusable={false}
      role="presentation"
      aria-hidden={true}
      {...props}
    >
      <path d="M1.17 8.54l1.31 13.09C2.55 22.18 5.18 24 9 24s6.45-1.82 6.53-2.37l1.3-13.09A16.79 16.79 0 019 10.2a16.82 16.82 0 01-7.83-1.66zm11.58-6.73l-1-1.14C11.34.1 10.91 0 10.08 0H7.92c-.83 0-1.26.1-1.65.67l-1 1.14c-3 .54-5.25 2-5.25 3V5C0 6.9 4 8.4 9 8.4s9-1.5 9-3.4v-.17c0-1.05-2.21-2.48-5.25-3.02zm-1.3 3.4L10.18 3.6H7.82L6.55 5.21h-2l2.5-3a.9.9 0 01.75-.38h2.42a.9.9 0 01.75.38l2.5 3z" />
    </svg>
  );
}

const MemoSvgTrash = React.memo(SvgTrash);
export default MemoSvgTrash;
